import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
// import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true,
// };

import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ImagenProfilePipe } from './navbar/imagen-profile.pipe';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BreadcrumsComponent } from './breadcrum/breadcrum.component';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { SubmenuComponent } from './sidebar/components/submenu/submenu.component';
import { NgScrollbarModule } from "ngx-scrollbar";


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CollapseModule,
    // PerfectScrollbarModule,
    BsDropdownModule,
    BreadcrumbModule,
    NgScrollbarModule
],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ImagenProfilePipe,
    BreadcrumsComponent,
    SubmenuComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ImagenProfilePipe,
    BreadcrumsComponent
  ],
  // providers: [
  //   {
  //     provide: PERFECT_SCROLLBAR_CONFIG,
  //     useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
  //   },
  // ],
})
export class ComponentsModule {}
